import React, { useContext } from 'react';

import { ADFRenderer } from '@confluence/adf-renderer/entry-points/ADFRenderer.ts';
import type { ADFRendererProps } from '@confluence/adf-renderer/entry-points/ADFRendererComponent.ts';

import { NestedLcmHierarchyContext } from './NestedLcmHierarchyContext.ts';
import { useNestedLcmProviderFactory } from './useNestedLcmProviderFactory.ts';

const InheritedExtensionRenderer = (props: ADFRendererProps) => {
	const dataProviders = useNestedLcmProviderFactory();

	return <ADFRenderer {...props} dataProviders={dataProviders} />;
};

/** Keep manifests reachable through macros that introduce another ADF renderer inside an LCM. */
export const NestedLcmADFRenderer = (props: ADFRendererProps): React.JSX.Element => {
	const isNestedLcmHierarchy = useContext(NestedLcmHierarchyContext);

	return isNestedLcmHierarchy ? (
		<InheritedExtensionRenderer {...props} />
	) : (
		<ADFRenderer {...props} />
	);
};
